import { useState } from 'react';
import { AppGraph, Component } from 'types/api-data';

export const useSearch = (data: AppGraph, domain: 'infra' | 'logical') => {
  const [searchTerm, setSearchTerm] = useState('');

  const dataTransform = (data: AppGraph) => {
    const filteredData = data.components.filter(
      (item: Component) => item.domain === domain
    );
    return filteredData;
  };

  // Filter services based on search term
  const filteredItems = data
    ? dataTransform(data).filter((item: Component) => {
        const searchLower = searchTerm.toLowerCase();
        return item.display_name?.toLowerCase().includes(searchLower);
      })
    : [];

  const handlerSearchChange = (value: string) => {
    setSearchTerm(value);
  };

  const handleClearSearch = () => {
    setSearchTerm('');
  };

  return {
    searchTerm,
    filteredItems,
    handlerSearchChange,
    handleClearSearch,
  };
};
